export default __webpack_public_path__ + "static/media/pl.b7ec32c4.jpg";